import { WinnerBall } from 'constants/common';
import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const saveWinnerBallToStoreAction = createAction(ACTIONS.SAVE_WINNER_BALL_TO_STORE)<{
  winner: WinnerBall | null;
}>();
